import styled from "styled-components";
import DatePicker from "react-datepicker";
import { primaryColor, primaryColorHover, errorColor } from "../../../../config/constants";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
`;
export const Modal = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px;
  width: 100%;
  max-width: 592px;
  height: 559px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.2);
`;
export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;
export const ModalTitle = styled.h3`
  font-size: 17px;
  color: #222;
`;
export const SectionTitle = styled.h4`
  margin-top: 26px;
  font-size: 15px;
  color: #222;
`;
export const CloseButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  outline: none;
  cursor: pointer;
`;
export const CloseIcon = styled.img`
  width: 24px;
  height: 24px;
`;
export const Description = styled.p`
  margin: 8px 0 20px;
  font-size: 12px;
  line-height: 1.5;
  color: #666;
`;
export const FieldsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 24px;
`;
export const Field = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Label = styled.label`
  margin-bottom: 6px;
  font-size: 13px;
  color: #333;
`;
const inputStyles = `
  padding: 9px 11px;
  width: 100%;
  border-radius: 5px;
  font-size: 13px;
  font-family: inherit;
  color: #333;
  outline: none;
  &::placeholder {
    color: #b5b5b5;
  }
`;
export const Input = styled.input`
  ${inputStyles}
  border: 1px solid ${({ $hasError }) => ($hasError ? errorColor : "#dcdcdc")};
  &:focus {
    border-color: ${({ $hasError }) => ($hasError ? errorColor : primaryColor)};
  }
`;
// El calendario se abre dentro de un modal con overflow, asi que se saca del
// flujo con un portal para que no lo recorte la ventana.
export const DateInput = styled(DatePicker)`
  ${inputStyles}
  border: 1px solid ${({ $hasError }) => ($hasError ? errorColor : "#dcdcdc")};
  &:focus {
    border-color: ${({ $hasError }) => ($hasError ? errorColor : primaryColor)};
  }
`;
export const ErrorMessage = styled.span`
  margin-top: 5px;
  font-size: 11.5px;
  color: ${errorColor};
`;
// Los botones quedan pegados abajo, para que el hueco inferior sea siempre el
// padding de 32px y no lo que sobre de la altura fija del modal.
export const Buttons = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: 14px;
  margin-top: auto;
  padding-top: 28px;
`;
const buttonStyles = `
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 1;
  padding: 0 10px;
  height: 40px;
  border-radius: 5px;
  font-size: 13px;
  font-family: inherit;
  outline: none;
  transition: all 0.15s ease-in-out;
`;
export const BackButton = styled.button`
  ${buttonStyles}
  border: 1px solid ${primaryColor};
  color: ${primaryColor};
  background-color: #fff;
  cursor: pointer;
  &:hover {
    background-color: #f2fbfc;
  }
`;
export const ExportButton = styled.button`
  ${buttonStyles}
  border: none;
  color: #fff;
  background-color: ${primaryColor};
  cursor: pointer;
  &:hover:enabled {
    background-color: ${primaryColorHover};
  }
  &:disabled {
    color: #9a9a9a;
    background-color: #e0e0e0;
    cursor: default;
  }
`;
export const ExportIcon = styled.img`
  width: 16px;
  height: 16px;
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.4 : 1)};
`;
